import { combineReducers } from "redux";
import AdminReducer from "./AdminReducer";
import LayoutReducer from "./LayoutReducer";
import StudyReducer from './StudyReducer';
export const rootReducer = combineReducers({
  Admin: AdminReducer,
  Theme: LayoutReducer,
  Study:StudyReducer
});
